/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HealthFindrBaseService } from '../health-findr-base-service';
import { HealthFindrApiConfiguration } from '../health-findr-api-configuration';
import { HealthFindrStrictHttpResponse } from '../health-findr-strict-http-response';

import { anonymousBroadcastMessagesPost } from '../fn/anonymous/anonymous-broadcast-messages-post';
import { AnonymousBroadcastMessagesPost$Params } from '../fn/anonymous/anonymous-broadcast-messages-post';
import { anonymousCommunicationBlobContentIdGet } from '../fn/anonymous/anonymous-communication-blob-content-id-get';
import { AnonymousCommunicationBlobContentIdGet$Params } from '../fn/anonymous/anonymous-communication-blob-content-id-get';
import { anonymousCommunicationBlobContentIdPost } from '../fn/anonymous/anonymous-communication-blob-content-id-post';
import { AnonymousCommunicationBlobContentIdPost$Params } from '../fn/anonymous/anonymous-communication-blob-content-id-post';
import { anonymousCommunicationBlobContentPost } from '../fn/anonymous/anonymous-communication-blob-content-post';
import { AnonymousCommunicationBlobContentPost$Params } from '../fn/anonymous/anonymous-communication-blob-content-post';
import { anonymousFhirIdSpecialityValidityGet } from '../fn/anonymous/anonymous-fhir-id-speciality-validity-get';
import { AnonymousFhirIdSpecialityValidityGet$Params } from '../fn/anonymous/anonymous-fhir-id-speciality-validity-get';
import { anonymousFormsPost } from '../fn/anonymous/anonymous-forms-post';
import { AnonymousFormsPost$Params } from '../fn/anonymous/anonymous-forms-post';
import { anonymousOriginalSpecialitiesGet } from '../fn/anonymous/anonymous-original-specialities-get';
import { AnonymousOriginalSpecialitiesGet$Params } from '../fn/anonymous/anonymous-original-specialities-get';
import { anonymousPromotionalLinkIdGet } from '../fn/anonymous/anonymous-promotional-link-id-get';
import { AnonymousPromotionalLinkIdGet$Params } from '../fn/anonymous/anonymous-promotional-link-id-get';
import { anonymousPromotionalLinkSlugSlugGet } from '../fn/anonymous/anonymous-promotional-link-slug-slug-get';
import { AnonymousPromotionalLinkSlugSlugGet$Params } from '../fn/anonymous/anonymous-promotional-link-slug-slug-get';
import { anonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet } from '../fn/anonymous/anonymous-service-configuration-extended-hours-of-operation-parent-organization-fhir-id-health-care-service-fhir-id-location-fhir-id-speciality-fhir-id-get';
import { AnonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params } from '../fn/anonymous/anonymous-service-configuration-extended-hours-of-operation-parent-organization-fhir-id-health-care-service-fhir-id-location-fhir-id-speciality-fhir-id-get';
import { anonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet } from '../fn/anonymous/anonymous-service-configuration-hours-of-operation-health-care-service-fhir-id-location-fhir-id-speciality-fhir-id-get';
import { AnonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params } from '../fn/anonymous/anonymous-service-configuration-hours-of-operation-health-care-service-fhir-id-location-fhir-id-speciality-fhir-id-get';
import { anonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet } from '../fn/anonymous/anonymous-service-confirmation-email-bin-organization-fhir-id-speciality-fhir-id-get';
import { AnonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet$Params } from '../fn/anonymous/anonymous-service-confirmation-email-bin-organization-fhir-id-speciality-fhir-id-get';
import { anonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet } from '../fn/anonymous/anonymous-service-hours-of-operation-health-care-service-fhir-id-location-fhir-id-speciality-fhir-id-get';
import { AnonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params } from '../fn/anonymous/anonymous-service-hours-of-operation-health-care-service-fhir-id-location-fhir-id-speciality-fhir-id-get';
import { anonymousSpecialityInstancesGet } from '../fn/anonymous/anonymous-speciality-instances-get';
import { AnonymousSpecialityInstancesGet$Params } from '../fn/anonymous/anonymous-speciality-instances-get';
import { anonymousSpecialityPromotionalLinkIdGet } from '../fn/anonymous/anonymous-speciality-promotional-link-id-get';
import { AnonymousSpecialityPromotionalLinkIdGet$Params } from '../fn/anonymous/anonymous-speciality-promotional-link-id-get';
import { anonymousSystemSpecialitiesGet } from '../fn/anonymous/anonymous-system-specialities-get';
import { AnonymousSystemSpecialitiesGet$Params } from '../fn/anonymous/anonymous-system-specialities-get';
import { anonymousTermsConditionsPost } from '../fn/anonymous/anonymous-terms-conditions-post';
import { AnonymousTermsConditionsPost$Params } from '../fn/anonymous/anonymous-terms-conditions-post';
import { OriginalSpecialityResultModel } from '../models/original-speciality-result-model';
import { PromotionalLinkModel } from '../models/promotional-link-model';
import { PromotionalLinkSpeciality } from '../models/promotional-link-speciality';
import { ServiceConfigurationModel } from '../models/service-configuration-model';
import { ServiceScheduleModel } from '../models/service-schedule-model';
import { SpecialityOrganizationInstance } from '../models/speciality-organization-instance';
import { SpecialityValidityResultModel } from '../models/speciality-validity-result-model';
import { SystemSpecialityResultModel } from '../models/system-speciality-result-model';
import { TermsConditionsModel } from '../models/terms-conditions-model';

@Injectable({ providedIn: 'root' })
export class HealthFindrAnonymousService extends HealthFindrBaseService {
  constructor(config: HealthFindrApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `anonymousPromotionalLinkIdGet()` */
  static readonly AnonymousPromotionalLinkIdGetPath = '/Anonymous/PromotionalLink/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousPromotionalLinkIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousPromotionalLinkIdGet$Response(params: AnonymousPromotionalLinkIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<PromotionalLinkModel>> {
    return anonymousPromotionalLinkIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousPromotionalLinkIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousPromotionalLinkIdGet(params: AnonymousPromotionalLinkIdGet$Params, context?: HttpContext): Observable<PromotionalLinkModel> {
    return this.anonymousPromotionalLinkIdGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<PromotionalLinkModel>): PromotionalLinkModel => r.body)
    );
  }

  /** Path part for operation `anonymousPromotionalLinkSlugSlugGet()` */
  static readonly AnonymousPromotionalLinkSlugSlugGetPath = '/Anonymous/PromotionalLink/Slug/{slug}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousPromotionalLinkSlugSlugGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousPromotionalLinkSlugSlugGet$Response(params: AnonymousPromotionalLinkSlugSlugGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<PromotionalLinkModel>> {
    return anonymousPromotionalLinkSlugSlugGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousPromotionalLinkSlugSlugGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousPromotionalLinkSlugSlugGet(params: AnonymousPromotionalLinkSlugSlugGet$Params, context?: HttpContext): Observable<PromotionalLinkModel> {
    return this.anonymousPromotionalLinkSlugSlugGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<PromotionalLinkModel>): PromotionalLinkModel => r.body)
    );
  }

  /** Path part for operation `anonymousSpecialityPromotionalLinkIdGet()` */
  static readonly AnonymousSpecialityPromotionalLinkIdGetPath = '/Anonymous/SpecialityPromotionalLink/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousSpecialityPromotionalLinkIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousSpecialityPromotionalLinkIdGet$Response(params: AnonymousSpecialityPromotionalLinkIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<PromotionalLinkSpeciality>> {
    return anonymousSpecialityPromotionalLinkIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousSpecialityPromotionalLinkIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousSpecialityPromotionalLinkIdGet(params: AnonymousSpecialityPromotionalLinkIdGet$Params, context?: HttpContext): Observable<PromotionalLinkSpeciality> {
    return this.anonymousSpecialityPromotionalLinkIdGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<PromotionalLinkSpeciality>): PromotionalLinkSpeciality => r.body)
    );
  }

  /** Path part for operation `anonymousBroadcastMessagesPost()` */
  static readonly AnonymousBroadcastMessagesPostPath = '/Anonymous/BroadcastMessages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousBroadcastMessagesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  anonymousBroadcastMessagesPost$Response(params?: AnonymousBroadcastMessagesPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<string>>> {
    return anonymousBroadcastMessagesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousBroadcastMessagesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  anonymousBroadcastMessagesPost(params?: AnonymousBroadcastMessagesPost$Params, context?: HttpContext): Observable<Array<string>> {
    return this.anonymousBroadcastMessagesPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `anonymousFormsPost()` */
  static readonly AnonymousFormsPostPath = '/Anonymous/Forms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousFormsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  anonymousFormsPost$Response(params?: AnonymousFormsPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<string>>> {
    return anonymousFormsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousFormsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  anonymousFormsPost(params?: AnonymousFormsPost$Params, context?: HttpContext): Observable<Array<string>> {
    return this.anonymousFormsPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `anonymousFhirIdSpecialityValidityGet()` */
  static readonly AnonymousFhirIdSpecialityValidityGetPath = '/Anonymous/{fhirId}/SpecialityValidity';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousFhirIdSpecialityValidityGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousFhirIdSpecialityValidityGet$Response(params: AnonymousFhirIdSpecialityValidityGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<SpecialityValidityResultModel>>> {
    return anonymousFhirIdSpecialityValidityGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousFhirIdSpecialityValidityGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousFhirIdSpecialityValidityGet(params: AnonymousFhirIdSpecialityValidityGet$Params, context?: HttpContext): Observable<Array<SpecialityValidityResultModel>> {
    return this.anonymousFhirIdSpecialityValidityGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<SpecialityValidityResultModel>>): Array<SpecialityValidityResultModel> => r.body)
    );
  }

  /** Path part for operation `anonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet()` */
  static readonly AnonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGetPath = '/Anonymous/ServiceHoursOfOperation/{healthCareServiceFhirId}/{locationFhirId}/{specialityFhirId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Response(params: AnonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<ServiceScheduleModel>> {
    return anonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet(params: AnonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<ServiceScheduleModel> {
    return this.anonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<ServiceScheduleModel>): ServiceScheduleModel => r.body)
    );
  }

  /** Path part for operation `anonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet()` */
  static readonly AnonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGetPath = '/Anonymous/ServiceConfigurationExtendedHoursOfOperation/{parentOrganizationFhirId}/{healthCareServiceFhirId}/{locationFhirId}/{specialityFhirId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Response(params: AnonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<ServiceConfigurationModel>> {
    return anonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet(params: AnonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<ServiceConfigurationModel> {
    return this.anonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<ServiceConfigurationModel>): ServiceConfigurationModel => r.body)
    );
  }

  /** Path part for operation `anonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet()` */
  static readonly AnonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGetPath = '/Anonymous/ServiceConfigurationHoursOfOperation/{healthCareServiceFhirId}/{locationFhirId}/{specialityFhirId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Response(params: AnonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<ServiceConfigurationModel>> {
    return anonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet(params: AnonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<ServiceConfigurationModel> {
    return this.anonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<ServiceConfigurationModel>): ServiceConfigurationModel => r.body)
    );
  }

  /** Path part for operation `anonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet()` */
  static readonly AnonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGetPath = '/Anonymous/ServiceConfirmationEmailBin/{organizationFhirId}/{specialityFhirId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet$Response(params: AnonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<string>>> {
    return anonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet(params: AnonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.anonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `anonymousCommunicationBlobContentIdPost()` */
  static readonly AnonymousCommunicationBlobContentIdPostPath = '/Anonymous/CommunicationBlobContentId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousCommunicationBlobContentIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  anonymousCommunicationBlobContentIdPost$Response(params?: AnonymousCommunicationBlobContentIdPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<string>> {
    return anonymousCommunicationBlobContentIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousCommunicationBlobContentIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  anonymousCommunicationBlobContentIdPost(params?: AnonymousCommunicationBlobContentIdPost$Params, context?: HttpContext): Observable<string> {
    return this.anonymousCommunicationBlobContentIdPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `anonymousCommunicationBlobContentPost()` */
  static readonly AnonymousCommunicationBlobContentPostPath = '/Anonymous/CommunicationBlobContent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousCommunicationBlobContentPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  anonymousCommunicationBlobContentPost$Response(params?: AnonymousCommunicationBlobContentPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<string>> {
    return anonymousCommunicationBlobContentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousCommunicationBlobContentPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  anonymousCommunicationBlobContentPost(params?: AnonymousCommunicationBlobContentPost$Params, context?: HttpContext): Observable<string> {
    return this.anonymousCommunicationBlobContentPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `anonymousCommunicationBlobContentIdGet()` */
  static readonly AnonymousCommunicationBlobContentIdGetPath = '/Anonymous/CommunicationBlobContent/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousCommunicationBlobContentIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousCommunicationBlobContentIdGet$Response(params: AnonymousCommunicationBlobContentIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<string>> {
    return anonymousCommunicationBlobContentIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousCommunicationBlobContentIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousCommunicationBlobContentIdGet(params: AnonymousCommunicationBlobContentIdGet$Params, context?: HttpContext): Observable<string> {
    return this.anonymousCommunicationBlobContentIdGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `anonymousTermsConditionsPost()` */
  static readonly AnonymousTermsConditionsPostPath = '/Anonymous/TermsConditions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousTermsConditionsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  anonymousTermsConditionsPost$Response(params?: AnonymousTermsConditionsPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<TermsConditionsModel>>> {
    return anonymousTermsConditionsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousTermsConditionsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  anonymousTermsConditionsPost(params?: AnonymousTermsConditionsPost$Params, context?: HttpContext): Observable<Array<TermsConditionsModel>> {
    return this.anonymousTermsConditionsPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<TermsConditionsModel>>): Array<TermsConditionsModel> => r.body)
    );
  }

  /** Path part for operation `anonymousSystemSpecialitiesGet()` */
  static readonly AnonymousSystemSpecialitiesGetPath = '/Anonymous/SystemSpecialities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousSystemSpecialitiesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousSystemSpecialitiesGet$Response(params?: AnonymousSystemSpecialitiesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<SystemSpecialityResultModel>>> {
    return anonymousSystemSpecialitiesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousSystemSpecialitiesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousSystemSpecialitiesGet(params?: AnonymousSystemSpecialitiesGet$Params, context?: HttpContext): Observable<Array<SystemSpecialityResultModel>> {
    return this.anonymousSystemSpecialitiesGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<SystemSpecialityResultModel>>): Array<SystemSpecialityResultModel> => r.body)
    );
  }

  /** Path part for operation `anonymousSpecialityInstancesGet()` */
  static readonly AnonymousSpecialityInstancesGetPath = '/Anonymous/SpecialityInstances';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousSpecialityInstancesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousSpecialityInstancesGet$Response(params?: AnonymousSpecialityInstancesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<SpecialityOrganizationInstance>>> {
    return anonymousSpecialityInstancesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousSpecialityInstancesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousSpecialityInstancesGet(params?: AnonymousSpecialityInstancesGet$Params, context?: HttpContext): Observable<Array<SpecialityOrganizationInstance>> {
    return this.anonymousSpecialityInstancesGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<SpecialityOrganizationInstance>>): Array<SpecialityOrganizationInstance> => r.body)
    );
  }

  /** Path part for operation `anonymousOriginalSpecialitiesGet()` */
  static readonly AnonymousOriginalSpecialitiesGetPath = '/Anonymous/OriginalSpecialities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymousOriginalSpecialitiesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousOriginalSpecialitiesGet$Response(params?: AnonymousOriginalSpecialitiesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<OriginalSpecialityResultModel>>> {
    return anonymousOriginalSpecialitiesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymousOriginalSpecialitiesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymousOriginalSpecialitiesGet(params?: AnonymousOriginalSpecialitiesGet$Params, context?: HttpContext): Observable<Array<OriginalSpecialityResultModel>> {
    return this.anonymousOriginalSpecialitiesGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<OriginalSpecialityResultModel>>): Array<OriginalSpecialityResultModel> => r.body)
    );
  }

}
